/**
 * Actionable error formatting utilities.
 *
 * Format: "Error: {what}. {why}. Fix: {action}"
 * All output goes to stderr to keep stdout clean for piped data.
 */
import chalk from "chalk";

/**
 * Print a fatal error message to stderr and exit with code 1.
 * Format: Error: {what}. {why}. Fix: {action}
 */
export function fatalError(what: string, why: string, fix: string): never {
  process.stderr.write(chalk.red(`Error: ${what}. ${why}. Fix: ${fix}`) + "\n");
  return process.exit(1) as never;
}

/**
 * Print a warning message to stderr without exiting.
 * Format: Warning: {what}. {why}. Fix: {action}
 */
export function warnAction(what: string, why: string, fix: string): void {
  process.stderr.write(chalk.yellow(`Warning: ${what}. ${why}. Fix: ${fix}`) + "\n");
}
